import React from 'react';

import { ALERT_TYPES } from '@bringg/types';

import { AlertNameCell, CommonTimeCell, TaskIdsCell } from '../cell-components';
import { sharedColumns } from './shared-columns';
import { columnMapper, filterOutIds } from './column-utils';
import { EXCEPTIONS_COLUMN_IDS } from '../../../consts';
import type { AlertCellProps, ColumnWithStrictId } from './column-utils';
import type { ElasticAlert, TranslatableOption } from '../../../types/common.consts';

// TODO: review ElasticAlert here, as Alert domain object type is passed as rows
export const columns: ColumnWithStrictId<ElasticAlert>[] = [
	sharedColumns.selection,
	{
		translateKey: 'ALERT_NAME',
		id: EXCEPTIONS_COLUMN_IDS.ALERT_TYPE,
		accessor: 'alert_type',
		filter: 'arrayIncludes',
		Cell: ({ row, value: alertType }: AlertCellProps<ALERT_TYPES>) => {
			// to render the grouped cell label this cell is used
			// the grouped cell doesn't have `original` object
			return <AlertNameCell alertType={alertType} extraData={row?.original?.extra_data} />;
		}
	},
	{
		translateKey: 'ALERT_TIME',
		id: EXCEPTIONS_COLUMN_IDS.ALERT_TIME,
		accessor: 'created_at',
		Cell: ({ value }: AlertCellProps<string>) => <CommonTimeCell dateString={value} timezone={null} />
	},
	{
		id: EXCEPTIONS_COLUMN_IDS.EXTERNAL_ID,
		translateKey: 'ID',
		accessor: 'task_id',
		disableSortBy: true,
		filter: 'taskIds',
		Cell: ({ value, row }: AlertCellProps<number>) => {
			return <TaskIdsCell extraData={row.original.extra_data} taskId={value} />;
		}
	},
	sharedColumns.team,
	sharedColumns.alertAdditionalText,
	{
		id: EXCEPTIONS_COLUMN_IDS.USER_ID,
		translateKey: 'USER_ID',
		accessor: 'user_id'
	},
	{
		id: 'data_user_name',
		translateKey: 'USER_NAME',
		// @ts-ignore
		accessor: (row: ElasticAlert) => row.extra_data.user_name
	},
	sharedColumns.severity,
	sharedColumns.actions,
	sharedColumns.alertOwner,
	sharedColumns.company
].map(col => {
	// @ts-ignore weird behavior I wasn't able to fix
	return columnMapper<ElasticAlert>(col);
});

export const defaultOrderedColumnOptions: TranslatableOption[] = columns
	.filter(({ id }) => !filterOutIds.has(id))
	.map(({ id, translateKey }) => ({ id, translateKey }));

export const driverAlertColumnsTranslateKeys = columns.reduce((acc, column) => {
	acc.set(column.id, column.translateKey);
	return acc;
}, new Map());
